<template>
    <portal>
        <h2>Create my plan page</h2>
    </portal>
</template>

<script>
import Portal from "@/components/Portal";
export default {
    components: {
        Portal
    }
}
</script>
